import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { CheckCircle } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { trackFBEvent } from "@/components/FacebookPixel";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const ContactUsThankYou = () => {
  const { t, language } = useLanguage();
  const navigate = useNavigate();
  const isThai = language === "th";

  useEffect(() => {
    trackFBEvent("CompleteRegistration", {
      content_name: "contact_us_form",
      status: "submitted",
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{isThai ? "ขอบคุณ | Carbonwize" : "Thank You | Carbonwize"}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Navbar />

      <main className="min-h-screen pt-[65px] flex items-center justify-center" style={{ backgroundColor: "#f9fafb" }}>
        <div className="container mx-auto px-4 py-16 text-center">
          <div className="max-w-lg mx-auto">
            <CheckCircle className="w-16 h-16 text-primary mx-auto mb-6" />
            <h1 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
              {isThai ? "ขอบคุณที่ติดต่อเรา!" : "Thank you for reaching out!"}
            </h1>
            <p className="text-muted-foreground text-lg mb-8">
              {isThai
                ? "ทีมงานจะติดต่อกลับหาคุณในไม่ช้า"
                : "Our dedicated team will get back to you shortly."}
            </p>
            <Button
              size="lg"
              className="bg-accent hover:bg-accent/90 text-accent-foreground font-semibold !rounded-full px-8"
              onClick={() => navigate("/")}
            >
              {isThai ? "กลับหน้าหลัก" : "Back to Home"}
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default ContactUsThankYou;
